import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { LinkList as LinkList$2, LinkListItem } from './LinkList.style.js';
import { jsx } from 'react/jsx-runtime';
import ArrowLink from '../../Link/ArrowLink.js';

var _excluded = ["text"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LinkList = function LinkList(_ref) {
  var cardSettings = _ref.cardSettings,
    links = _ref.links,
    title = _ref.title;
  return /*#__PURE__*/jsx(LinkList$2, _objectSpread(_objectSpread({}, cardSettings), {}, {
    children: links.map(function (link) {
      var text = link.text,
        linkRest = _objectWithoutProperties(link, _excluded);
      return /*#__PURE__*/jsx(LinkListItem, {
        children: /*#__PURE__*/jsx(ArrowLink, _objectSpread(_objectSpread({}, linkRest), {}, {
          ariaLabel: "".concat(title, ", ").concat(text),
          children: text
        }))
      }, text);
    })
  }));
};
var LinkList$1 = LinkList;

export { LinkList$1 as default };
//# sourceMappingURL=LinkList.js.map
